const dynamicPanelLoader = panelName => () =>
  import(`@/panel/${panelName}`).then(module => module.default);

export default dynamicPanelLoader;
